import ChartNivAnafylaxie from "../../../../src/client/niv_acuteboekje/json/anafylaxie.json";
import ChartNivSchematic from "../../../../src/client/niv_acuteboekje/interactions/chart_schematic/ChartNivSchematic";
import * as React from 'react';
export default {
  ChartNivAnafylaxie,
  ChartNivSchematic,
  React
};